@if (isChatOpen()) {
  <div
    class="tw-fixed tw-right-6 tw-bottom-24 tw-z-[1000] tw-flex tw-flex-col tw-w-[380px] tw-h-[600px] tw-bg-dt-surface-card tw-rounded-2xl tw-overflow-hidden tw-border tw-border-color-border-subtle xs:tw-right-4 xs:tw-bottom-20 xs:tw-w-[240px] xs:tw-h-[55vh]"
  >
    <div
      class="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3 tw-bg-dt-surface-card border-bottom-gray"
    >
      <span class="tw-font-medium tw-text-gray-800">{{ title }}</span>
      <div class="tw-flex tw-items-center tw-gap-2">
        <button
          class="tw-bg-blue-600 tw-text-dt-text-contrast tw-px-3 tw-py-1 tw-text-sm tw-rounded hover:tw-bg-blue-700"
          (click)="sendRoutes()"
        >
          Set Context
        </button>
        <app-gloss-button
          [options]="{
            class: 'neutral',
            icon: 'close',
            ariaLabel: 'closeChat' | i18n,
            onClick: closeChat.bind(this),
            isEnabled: true,
          }"
        ></app-gloss-button>
      </div>
    </div>

    <div class="tw-flex-grow tw-relative">
      <iframe
        #chatbotIframe
        [src]="safeChatUrl"
        class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-border-none"
        allow="web-share; display-capture; keyboard-map; xr-spatial-tracking; webgpu"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-downloads"
      ></iframe>
    </div>
  </div>
}
